import { useQuery } from '@tanstack/react-query'
import { api, schoolApi } from '../lib/api'
import { polling } from '../lib/polling'

export const commandKeys = {
  all: ['commands'] as const,
  detail: (id: string) => [...commandKeys.all, id] as const,
  milestones: (id: string) => [...commandKeys.detail(id), 'milestones'] as const,
  active: () => [...commandKeys.all, 'active'] as const,
}

function shouldRetry(failureCount: number, error: Error): boolean {
  if (error.message?.includes('Command not found')) return false
  return failureCount < 2
}

export function useCommandStatus(commandId: string, options?: { enabled?: boolean; refetchInterval?: number | false; schoolId?: string }) {
  return useQuery({
    queryKey: commandKeys.detail(commandId),
    queryFn: () => options?.schoolId
      ? schoolApi.getCommandStatus(options.schoolId, commandId)
      : api.getCommandStatus(commandId),
    enabled: options?.enabled !== false && !!commandId,
    refetchInterval: options?.refetchInterval ?? polling.commandFallback,
    retry: shouldRetry,
  })
}

export function useCommandMilestones(commandId: string, options?: { enabled?: boolean; refetchInterval?: number | false; schoolId?: string }) {
  return useQuery({
    queryKey: commandKeys.milestones(commandId),
    queryFn: () => options?.schoolId
      ? schoolApi.getCommandMilestones(options.schoolId, commandId)
      : api.getCommandMilestones(commandId),
    enabled: options?.enabled !== false && !!commandId,
    refetchInterval: options?.refetchInterval ?? polling.commandFallback,
    retry: shouldRetry,
  })
}

export function useActiveCommands(options?: { enabled?: boolean; refetchInterval?: number | false }) {
  return useQuery({
    queryKey: commandKeys.active(),
    queryFn: () => api.getActiveCommands(),
    enabled: options?.enabled !== false,
    refetchInterval: options?.refetchInterval ?? polling.activeCommands,
  })
}
